import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserContactCompanyOutput } from 'user/model/contact/user-contact-company.output';
import { userContactCompany } from 'user/model/user.fragments';

import { ApiQuery } from '../../../../../common/model/api.query';

@Injectable({ providedIn: 'root' })
export class FetchUserContactCompaniesApiQuery extends ApiQuery<
	UserContactCompanyOutput[],
	void
> {
	client = 'iam';
	document = gql`
		query FetchUserContactCompanies {
			fetchUserContactCompanies {
				...UserContactCompany
			}
		}
		${userContactCompany}
	`;
	method = 'fetchUserContactCompanies';
}
